<template>
  <div class="d-flex justify-center align-center flex-column mt-10">
    <div class="h2">Loading the login page...</div>
    <v-btn text small class="text-none" @click="login" :loading="loggedIn" :disabled="loggedIn">Take me there!</v-btn>
  </div>
</template>

<script>
import AuthService from "@/services/AuthService";

export default {
  name: "Login",
  data() {
    return {
      loggedIn: false
    }
  },
  methods: {
    async login() {
      await AuthService.login()
    }
  },
  mounted() {
    console.log('login mounted')
    if(this.$route.query.redirect) {
      localStorage.setItem('redirect', this.$route.query.redirect)
    }
    if(this.$store.state.loggedIn) {
      const rd = localStorage.getItem('redirect')
      const redirect = rd && rd !== 'undefined' ? rd : '/'
      this.$router.replace(redirect)
    } else {
      this.login()
    }
  }
}
</script>

<style scoped>

</style>